import { Box, Button, IconButton, Menu, MenuButton, MenuItem, MenuList, Text } from '@chakra-ui/react'
import { CheckIcon } from '@chakra-ui/icons'
import { FaLanguage } from 'react-icons/fa'
import { useTranslation } from 'react-i18next'

type LanguageSwitcherProps = {
  inMenu?: boolean;
}

const LanguageSwitcher = ({ inMenu = false }: LanguageSwitcherProps) => {
  const { t, i18n } = useTranslation()
  const language = i18n.resolvedLanguage?.split('-')[0] || 'bg'

  const changeLanguage = (nextLanguage: string) => {
    i18n.changeLanguage(nextLanguage)
    window.localStorage.setItem('inchilza-language', nextLanguage)
  }

  if (inMenu) {
    const nextLanguage = language === 'en' ? 'bg' : 'en'
    const nextLabel = language === 'en'
      ? t('language.switchToBulgarian')
      : t('language.switchToEnglish')
    const nextFlag = nextLanguage === 'bg' ? '🇧🇬' : '🇬🇧'

    return (
      <Button
        onClick={() => changeLanguage(nextLanguage)}
        width="100%"
        justifyContent="flex-start"
        leftIcon={<Text fontSize="lg" lineHeight="1">{nextFlag}</Text>}
        aria-label={nextLabel}
        variant="ghost"
        borderRadius="10px"
        bg="rgba(255,255,255,0.65)"
        _hover={{ bg: 'rgba(255,255,255,0.9)' }}
      >
        {nextLabel}
      </Button>
    )
  }

  return (
    <Menu placement="bottom-end">
      <MenuButton
        as={IconButton}
        icon={<FaLanguage size="22px" />}
        aria-label={t('language.select')}
        variant="ghost"
        borderRadius="10px"
        width="auto"
        justifyContent="center"
        marginRight={{ base: 2, md: 3 }}
        bg="rgba(255,255,255,0.65)"
        _hover={{ bg: 'rgba(255,255,255,0.9)' }}
      />
      <MenuList
        minWidth="180px"
        bg="rgba(255,255,255,0.95)"
        boxShadow="lg"
        borderColor="purple.100"
        zIndex={100}
      >
        <MenuItem onClick={() => changeLanguage('bg')} fontWeight={language === 'bg' ? 'bold' : 'normal'}>
          <Box width="22px">{language === 'bg' ? <CheckIcon /> : null}</Box>
          <Text>{t('language.bulgarian')}</Text>
        </MenuItem>
        <MenuItem onClick={() => changeLanguage('en')} fontWeight={language === 'en' ? 'bold' : 'normal'}>
          <Box width="22px">{language === 'en' ? <CheckIcon /> : null}</Box>
          <Text>{t('language.english')}</Text>
        </MenuItem>
      </MenuList>
    </Menu>
  )
}

export default LanguageSwitcher
